export default __webpack_public_path__ + "static/media/section3_1_0.888f84a0.png";